import { Report, ReportingUpType } from "../../services/reporting";
import { DelayedReport, getDelayedKey } from "../delayedReport/delayedReport";
import { googleTagManager } from "../../utils/googleAnalytics";
import promisify from "../../utils/promisify";
export const PRODUCT_FROM_SEARCH = "product-seen-from-search";
export const PRODUCT_FROM_CATEGORY = "product-seen-from-category";
export const PRODUCT_FROM_LANDING_PAGE = "product-seen-from-landing-page";
export function hasSvelteSERPDelayedReport() {
    return getDelayedKey(PRODUCT_FROM_SEARCH) in localStorage || getDelayedKey(PRODUCT_FROM_CATEGORY) in localStorage || getDelayedKey(PRODUCT_FROM_LANDING_PAGE) in localStorage;
}
export const Serp = (getBase) => ({
    reportSearchPreformed: (props, src) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const isNoResults = props === null || props === void 0 ? void 0 : props.no_results;
        const landingPage = props === null || props === void 0 ? void 0 : props.landing_page;
        let gtagHasNarrow = null;
        if (props === null || props === void 0 ? void 0 : props.gtag_has_narrow) {
            gtagHasNarrow = props.gtag_has_narrow;
            delete props.gtag_has_narrow;
        }
        if (props === null || props === void 0 ? void 0 : props.gtag_product_items) {
            if (!(((_a = window === null || window === void 0 ? void 0 : window.__fast_options) === null || _a === void 0 ? void 0 : _a.avoidDefaultViewItemListEvent) === true) && !(((_b = window === null || window === void 0 ? void 0 : window.__fastOptions) === null || _b === void 0 ? void 0 : _b.avoidDefaultViewItemListEvent) === true)) {
                googleTagManager('event', 'view_item_list', Object.assign({ items: props.gtag_product_items }, (gtagHasNarrow ? { category: 'filter' } : {})), src);
            }
            try {
                if (typeof ((_c = window === null || window === void 0 ? void 0 : window.__fast_options) === null || _c === void 0 ? void 0 : _c.viewItemListCallback) === "function") {
                    (_e = (_d = window === null || window === void 0 ? void 0 : window.__fast_options) === null || _d === void 0 ? void 0 : _d.viewItemListCallback) === null || _e === void 0 ? void 0 : _e.call(_d, Object.assign({ items: props.gtag_product_items, promotions: props.gtag_product_promotions }, (gtagHasNarrow ? { category: 'filter' } : {})));
                }
                else if (typeof ((_f = window === null || window === void 0 ? void 0 : window.__fastOptions) === null || _f === void 0 ? void 0 : _f.viewItemListCallback) === "function") {
                    (_h = (_g = window === null || window === void 0 ? void 0 : window.__fastOptions) === null || _g === void 0 ? void 0 : _g.viewItemListCallback) === null || _h === void 0 ? void 0 : _h.call(_g, Object.assign({ items: props.gtag_product_items, promotions: props.gtag_product_promotions }, (gtagHasNarrow ? { category: 'filter' } : {})));
                }
            }
            catch (e) {
                console.log(`%c❌ Fast Simon Reporting Error | Error in viewItemListCallback Method`, "font-weight: bold; font-size: 12px; color: red");
            }
            delete props.gtag_product_items;
        }
        if (props === null || props === void 0 ? void 0 : props.gtag_product_promotions) {
            if (!(((_j = window === null || window === void 0 ? void 0 : window.__fast_options) === null || _j === void 0 ? void 0 : _j.avoidDefaultViewItemListEvent) === true) && !(((_k = window === null || window === void 0 ? void 0 : window.__fastOptions) === null || _k === void 0 ? void 0 : _k.avoidDefaultViewItemListEvent) === true)) {
                googleTagManager('event', 'view_promotions', { items: props.gtag_product_promotions }, src);
            }
            delete props.gtag_product_promotions;
        }
        if (typeof (props === null || props === void 0 ? void 0 : props.no_results) !== 'undefined') {
            delete props.no_results;
        }
        if (typeof (props === null || props === void 0 ? void 0 : props.landing_page) !== 'undefined') {
            delete props.landing_page;
        }
        return Report(Object.assign(Object.assign({}, getBase()), { upType: isNoResults ? ReportingUpType.searchPreformedNoResults
                : landingPage ? ReportingUpType.landingPageSeen
                    : ReportingUpType.searchPreformed, params: props }));
    },
    reportSmartNavigationPreformed: (props, src) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        let gtagHasNarrow = null;
        let fromTurbolink = false;
        let baseURLparts = window.location.href.split("?");
        if (baseURLparts.length > 0) {
            let baseURL = baseURLparts[0];
            if (localStorage.getItem("collectionClickedFromTurboLink") && localStorage.getItem("collectionClickedFromTurboLink") == baseURL && localStorage.getItem("collectionClickedFromTurboLink-Serach-Query")) {
                fromTurbolink = true;
                props.original_search_query = (_a = localStorage.getItem("collectionClickedFromTurboLink-Serach-Query")) !== null && _a !== void 0 ? _a : undefined;
                localStorage.removeItem("collectionClickedFromTurboLink");
                localStorage.removeItem("collectionClickedFromTurboLink-Serach-Query");
            }
            else if (localStorage.getItem("collectionClickedFromTurboLink")) {
                localStorage.removeItem("collectionClickedFromTurboLink");
                localStorage.removeItem("collectionClickedFromTurboLink-Serach-Query");
            }
        }
        if (props === null || props === void 0 ? void 0 : props.gtag_has_narrow) {
            gtagHasNarrow = props.gtag_has_narrow;
            delete props.gtag_has_narrow;
        }
        if (props === null || props === void 0 ? void 0 : props.gtag_product_items) {
            if (!(((_b = window === null || window === void 0 ? void 0 : window.__fast_options) === null || _b === void 0 ? void 0 : _b.avoidDefaultViewItemListEvent) === true) && !(((_c = window === null || window === void 0 ? void 0 : window.__fastOptions) === null || _c === void 0 ? void 0 : _c.avoidDefaultViewItemListEvent) === true)) {
                googleTagManager('event', 'view_item_list', Object.assign({ items: props.gtag_product_items }, (gtagHasNarrow ? { category: 'filter' } : {})), src);
            }
            try {
                if (typeof ((_d = window === null || window === void 0 ? void 0 : window.__fast_options) === null || _d === void 0 ? void 0 : _d.viewItemListCallback) === "function") {
                    (_f = (_e = window === null || window === void 0 ? void 0 : window.__fast_options) === null || _e === void 0 ? void 0 : _e.viewItemListCallback) === null || _f === void 0 ? void 0 : _f.call(_e, Object.assign({ items: props.gtag_product_items, promotions: props.gtag_product_promotions }, (gtagHasNarrow ? { category: "filter" } : {})));
                }
                else if (typeof ((_g = window === null || window === void 0 ? void 0 : window.__fastOptions) === null || _g === void 0 ? void 0 : _g.viewItemListCallback) === "function") {
                    (_j = (_h = window === null || window === void 0 ? void 0 : window.__fastOptions) === null || _h === void 0 ? void 0 : _h.viewItemListCallback) === null || _j === void 0 ? void 0 : _j.call(_h, Object.assign({ items: props.gtag_product_items, promotions: props.gtag_product_promotions }, (gtagHasNarrow ? { category: "filter" } : {})));
                }
            }
            catch (e) {
                console.log(`%c❌ Fast Simon Reporting Error | Error in viewItemListCallback Method`, 'font-weight: bold; font-size: 12px; color: red');
            }
            delete props.gtag_product_items;
        }
        if (props === null || props === void 0 ? void 0 : props.gtag_product_promotions) {
            if (!(((_k = window === null || window === void 0 ? void 0 : window.__fast_options) === null || _k === void 0 ? void 0 : _k.avoidDefaultViewItemListEvent) === true) && !(((_l = window === null || window === void 0 ? void 0 : window.__fastOptions) === null || _l === void 0 ? void 0 : _l.avoidDefaultViewItemListEvent) === true)) {
                googleTagManager('event', 'view_promotions', { items: props.gtag_product_promotions }, src);
            }
            delete props.gtag_product_promotions;
        }
        return Report(Object.assign(Object.assign({}, getBase()), { upType: fromTurbolink ? ReportingUpType.collectionPreformedFromTurbolink : ReportingUpType.collectionPreformed, params: props }));
    },
    productClickedFromSearch: (props, src) => {
        if (props === null || props === void 0 ? void 0 : props.gtag_product_items) {
            googleTagManager('event', 'select_item', { items: props.gtag_product_items }, src);
            delete props.gtag_product_items;
        }
        return DelayedReport(Object.assign(Object.assign({}, getBase()), { prefix: PRODUCT_FROM_SEARCH, params: props }));
    },
    productClickedFromSmartNavigation: (props, src) => {
        if (props === null || props === void 0 ? void 0 : props.gtag_product_items) {
            googleTagManager('event', 'select_item', { items: props.gtag_product_items }, src);
            delete props.gtag_product_items;
        }
        return DelayedReport(Object.assign(Object.assign({}, getBase()), { prefix: PRODUCT_FROM_CATEGORY, params: props }));
    },
    productClickedFromLandingPage: (props) => {
        if (props === null || props === void 0 ? void 0 : props.gtag_product_items) {
            googleTagManager('event', 'select_item', { items: props.gtag_product_items });
            delete props.gtag_product_items;
        }
        return DelayedReport(Object.assign(Object.assign({}, getBase()), { prefix: PRODUCT_FROM_LANDING_PAGE, upType: ReportingUpType.landingPageSeen, params: props }));
    },
    quickViewUsedFromSearch: (props) => {
        return Report(Object.assign(Object.assign({}, getBase()), { upType: ReportingUpType.popUpUsedQuickView, params: props }));
    },
    quickViewUsedFromSmartNavigation: (props) => {
        return Report(Object.assign(Object.assign({}, getBase()), { upType: ReportingUpType.popUpUsedQuickView, params: props }));
    },
    LookALikeUsedFromSearch: (props) => {
        return Report(Object.assign(Object.assign({}, getBase()), { upType: ReportingUpType.popUpUsedLookALike, params: props }));
    },
    LookALikeUsedFromSmartNavigation: (props) => {
        return Report(Object.assign(Object.assign({}, getBase()), { upType: ReportingUpType.popUpUsedLookALike, params: props }));
    },
    reportProductAddedToCart: (props) => {
        props['cart'] = 1;
        if (props === null || props === void 0 ? void 0 : props.gtag_product_items) {
            googleTagManager('event', 'add_to_cart', { items: props.gtag_product_items });
            delete props.gtag_product_items;
        }
        return Report(Object.assign(Object.assign({}, getBase()), { params: props }));
    },
    productHover: (props) => {
        return Report(Object.assign(Object.assign({}, getBase()), { upType: ReportingUpType.hoverOnProduct, params: props }));
    },
    variantHover: (props) => {
        return Report(Object.assign(Object.assign({}, getBase()), { upType: ReportingUpType.hoverOnProductVariant, params: props }));
    },
    promoTileClickedFromSearch: (props, src) => {
        if (props === null || props === void 0 ? void 0 : props.gtag_product_items) {
            googleTagManager('event', 'select_promotion', { items: props.gtag_product_items }, src);
            delete props.gtag_product_items;
        }
        return DelayedReport(Object.assign(Object.assign({}, getBase()), { prefix: PRODUCT_FROM_SEARCH, params: props, upType: ReportingUpType.promoTileClicked }));
    },
    promoTileClickedFromSmartNavigation: (props, src) => {
        if (props === null || props === void 0 ? void 0 : props.gtag_product_items) {
            googleTagManager('event', 'select_promotion', { items: props.gtag_product_items }, src);
            delete props.gtag_product_items;
        }
        return DelayedReport(Object.assign(Object.assign({}, getBase()), { prefix: PRODUCT_FROM_CATEGORY, params: props, upType: ReportingUpType.promoTileClicked }));
    },
    reportSearchPageViewed: (props, src) => {
        if (props === null || props === void 0 ? void 0 : props.query) {
            googleTagManager("event", "view_search_results", {
                page: {
                    searchTerm: props === null || props === void 0 ? void 0 : props.query,
                    searchResults: props === null || props === void 0 ? void 0 : props.totalResults
                }
            }, src);
        }
        return promisify(() => true);
    }
});
//# sourceMappingURL=serp.js.map